/**
 * Модуль для управления элементами управления боем
 */

/**
 * Создаёт менеджер для управления элементами управления боем
 */
export function createBattleControlsManager({
  togglePlayback,
  stepBackward,
  stepForward,
  seekToStep,
  setPlaybackSpeed,
  closeBattleModal,
  getBattleState,
  documentRef = document,
}) {
  /**
   * Настраивает элементы управления воспроизведением боя
   */
  function setupBattlePlaybackControls() {
    const playButton = documentRef.getElementById("battle-playback-play");
    const stepBackButton = documentRef.getElementById("battle-playback-step-back");
    const stepForwardButton = documentRef.getElementById("battle-playback-step-forward");
    const slider = documentRef.getElementById("battle-playback-slider");
    const speedSelect = documentRef.getElementById("battle-playback-speed");
    const jumpToStartButton = documentRef.getElementById("battle-playback-jump-start");
    const jumpToEndButton = documentRef.getElementById("battle-playback-jump-end");

    if (playButton) {
      playButton.addEventListener("click", () => {
        if (togglePlayback) {
          togglePlayback();
        }
      });
    }

    if (stepBackButton) {
      stepBackButton.addEventListener("click", () => {
        if (stepBackward) {
          stepBackward();
        }
      });
    }

    if (stepForwardButton) {
      stepForwardButton.addEventListener("click", () => {
        if (stepForward) {
          stepForward();
        }
      });
    }

    if (slider) {
      slider.addEventListener("input", (event) => {
        const step = Number(event.target.value || 0);
        if (seekToStep) {
          seekToStep(step);
        }
      });
    }

    if (speedSelect) {
      speedSelect.addEventListener("change", (event) => {
        const speed = event.target.value;
        if (setPlaybackSpeed) {
          setPlaybackSpeed(speed);
        }
      });
    }

    // Быстрая навигация: переход к началу
    if (jumpToStartButton) {
      jumpToStartButton.addEventListener("click", () => {
        if (seekToStep) {
          seekToStep(0);
        }
      });
    }

    // Быстрая навигация: переход к концу
    if (jumpToEndButton) {
      jumpToEndButton.addEventListener("click", () => {
        const state = getBattleState();
        if (state && state.timeline && seekToStep) {
          seekToStep(Math.max(0, state.timeline.length - 1));
        }
      });
    }
  }

  /**
   * Настраивает обработчики модального окна боя
   */
  function setupBattleModalHandlers() {
    const modal = documentRef.getElementById("battle-modal");
    const closeButton = documentRef.getElementById("battle-modal-close");

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        if (closeBattleModal) {
          closeBattleModal({ reset: true });
        }
      });
    }

    if (modal) {
      modal.addEventListener("click", (event) => {
        if (event.target === modal && closeBattleModal) {
          closeBattleModal({ reset: true });
        }
      });
    }

    documentRef.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && closeBattleModal) {
        closeBattleModal({ reset: true });
      }
    });
  }

  return {
    setupBattlePlaybackControls,
    setupBattleModalHandlers,
  };
}









